/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { currentCluster } from '@app/core/ngrx';
import { AppState } from '@app/core/types';
import { Action, Store } from '@ngrx/store';
import { EMPTY, Observable, of } from 'rxjs';
import { switchMap, withLatestFrom } from 'rxjs/operators';

export const withClusterId =
  <T1 extends Action, T2 extends Action>(store: Store<AppState>, mapFn: (action: T1, clusterId: string) => T2) =>
  (source: Observable<T1>) =>
    source.pipe(
      withLatestFrom(store.select(currentCluster)),
      switchMap(([action, clusterId]) => (!clusterId ? EMPTY : of(mapFn(action, clusterId)))),
    );
